export default require('./Panel-Info.vue').default